import { BrowserModule } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA, provideZoneChangeDetection } from '@angular/core';
import { FormsModule } from '@angular/forms'; // <-- NgModel lives here
import { RouterModule } from '@angular/router';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { ReactiveFormsModule } from '@angular/forms';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MessagesComponent } from './messages/messages.component';
import { ProcDefComponent } from './proc-def-list/proc-def-list.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { ProcDefDetailComponent } from './proc-def-detail/proc-def-detail.component';
import { ProcInstListComponent } from './proc-inst-list/proc-inst-list.component';
import { ProcInstDetailComponent } from './proc-inst-detail/proc-inst-detail.component';
import { JobListComponent } from './job-list/job-list.component';
import { JobDetailComponent } from './job-detail/job-detail.component';
import { PaginationComponent } from './pagination/pagination.component';
import { AppListComponent } from './app-list/app-list.component';
import { AppDetailComponent } from './app-detail/app-detail.component';
import { AppUploadComponent } from './app-upload/app-upload.component';
import { ProcStarterComponent } from './proc-starter/proc-starter.component';
import { FriendlyDurationPipe } from './friendly-duration.pipe';
import { ServiceWorkerModule } from '@angular/service-worker';
import { shouldRegisterServiceWorker } from './service-worker-config';

@NgModule({ declarations: [
        AppComponent
    ],
    bootstrap: [AppComponent], imports: [BrowserModule,
        CommonModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        FormsModule,
        RouterModule,
        ReactiveFormsModule,
        MessagesComponent,
        DashboardComponent,
        ProcDefComponent,
        ProcDefDetailComponent,
        ProcInstListComponent,
        ProcInstDetailComponent,
        JobListComponent,
        JobDetailComponent,
        PaginationComponent,
        AppListComponent,
        AppDetailComponent,
        AppUploadComponent,
        ProcStarterComponent,
        FriendlyDurationPipe,
        ServiceWorkerModule.register('ngsw-worker.js', {
            enabled: shouldRegisterServiceWorker(),
            // Register the ServiceWorker as soon as the app is stable
            // or after 30 seconds (whichever comes first).
            registrationStrategy: 'registerWhenStable:30000'
        })], providers: [
        provideZoneChangeDetection(),
        provideHttpClient(withInterceptorsFromDi())
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA]
})
export class AppModule { }
